import { Card, CardContent } from '@mui/material';
import {
  Datagrid,
  List,
  TextField,
  ReferenceField,
  ReferenceArrayField,
  FunctionField,
  EditButton,
  useListContext,
  DateField,
} from 'react-admin';
import { parseCronExpression } from '../../utils';
import { IndexField, CustomActions } from '../../components';
import { useCognitoUser } from '../../hooks';


const OperatorsField = () => {
  const { data, isLoading } = useListContext(); // Get the list of related users

  if (isLoading || !data) return null;

  return (
    <span style={{ color: 'white' }}>
      {data.map((user, index, array) => (
        <span key={user.id}>
          {user.name}
          {index !== array.length - 1 ? ', ' : ''}
        </span>
      ))}
    </span>
  );
};

const ListSchedule = () => {
  const currentUser = useCognitoUser();

  return (
    <Card variant='elevation'>
      <CardContent>
        <List actions={<CustomActions title='Manage Schedules' addBtnLabel='Add Schedule' type={`${currentUser.group !== 'customer' && 'list'}`} />}>
          <Datagrid rowClick='edit' size='medium' bulkActionButtons={false} sx={{ borderTop: '1px solid grey', maxHeight: '70vh', overflow: 'auto' }}>
            <FunctionField
              label='NO'
              render={(record) => <IndexField record={record} />}
            />
            <FunctionField
              label='SELECTED DAY'
              source='cron_expression'
              sortable={false}
              render={(record) => {
                let selectedDays = parseCronExpression(record.cron_expression)?.days || [];
                selectedDays = selectedDays.length === 7 ? ['Daily'] : selectedDays;
                return selectedDays.map((sd, id, list) => <span key={id}>{sd}{id < list.length - 1 && `,`}</span>)
              }}
              style={{
                display: 'flex',
                maxWidth: '200px',
                flexWrap: 'wrap',
              }}
            />
            <FunctionField
              label='TIME'
              render={(record) => parseCronExpression(record.cron_expression)?.time || '-'}
            />
            <ReferenceField source="route_id" reference="routes" label='ROUTE' link='' sortable={false}>
              <TextField source='name' style={{ color: 'white' }} />
            </ReferenceField>
            <ReferenceArrayField label="Operators" reference="cognitoUsers" source="operator_ids" sortable={false}>
              <OperatorsField />
            </ReferenceArrayField>
            <DateField label="MODIFIED TIME" source='updatedAt' showTime sortable={false} />
            <FunctionField
              label="ACTION"
              render={(record) => <EditButton label='' record={record} sx={{ color: 'white' }} />}
            />
          </Datagrid>
        </List>
      </CardContent>
    </Card>
  )
};

export default ListSchedule;
export { ListSchedule };